import React from "react";
import { WritingStatsProps } from "./IWritingResut";
import { FileText } from "lucide-react";

const WritingStatsCard: React.FC<{ data: WritingStatsProps }> = ({ data }) => {
  const getStatusStyle = (status: string): React.CSSProperties => {
    switch (status) {
      case "Excellent":
        return { backgroundColor: "#d1fae5", color: "#065f46" };
      case "Good":
        return { backgroundColor: "#fef9c3", color: "#854d0e" };
      case "Average":
        return { backgroundColor: "#e0f2fe", color: "#075985" };
      default:
        return { backgroundColor: "#fee2e2", color: "#7f1d1d" };
    }
  };

  return (
    <div style={styles.card}>
      <div style={styles.header}>
        <span style={styles.icon}>
          <FileText />
        </span>
        <h3 style={styles.title}>{data.title}</h3>
      </div>

      <div style={styles.grid}>
        <StatBox label="Words Written" value={data.wordsWritten} />
        <StatBox label="Characters" value={data.characters} />
        <StatBox label="Sentences" value={data.sentences} />
        <StatBox label="Paragraphs" value={data.paragraphs} />
      </div>

      <div style={{ ...styles.statusBox, ...getStatusStyle(data.status) }}>
        <strong style={{ fontSize: "16px" }}>{data.status}</strong>
        <p style={{ margin: 0, fontSize: "13px" }}>{data.efficiency}</p>
      </div>
    </div>
  );
};

const StatBox: React.FC<{ label: string; value: number }> = ({
  label,
  value,
}) => (
  <div style={styles.statItem}>
    <h2
      style={{
        margin: 0,
        fontSize: "22px",
        fontWeight: "700",
        lineHeight: "22px",
      }}
    >
      {value}
    </h2>
    <p style={{ margin: 0, fontSize: "13px" }}>{label}</p>
  </div>
);

const styles: Record<string, React.CSSProperties> = {
  card: {
    border: "1px solid #e5e7eb",
    padding: 20,
    borderRadius: 12,
    background: "#fff",
  },

  icon: { fontSize: "24px", color: "#009ddf" },
  header: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    marginBottom: 28,
  },
  title: {
    fontSize: "18px",
    fontWeight: 600,
    marginBottom: 18,
    color: "#111827",
    margin: 0,
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: 16,
  },
  statItem: {
    backgroundColor: "#f9fafb",
    padding: 14,
    borderRadius: 10,
    textAlign: "center",
  },
  statusBox: {
    marginTop: 20,
    padding: 12,
    borderRadius: 8,
    backgroundColor: "#d1fae5",
    textAlign: "center",
    // border: "1px solid #10b981",
  },
};

export default WritingStatsCard;
